import { MetadataType } from '@aibees/elephant/hooks';
import { capitalize } from '@aibees/shared/utils';
import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';

export default function employeeSizeFilterConfig(): SearchFilterBase {
  return {
    id: 'Employee Size',
    name: 'Employee Size',
    icon: 'groups-outlined',
    index: 4,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    items: [
      {
        name: '',
        type: SearchFilterType.RADIO_GROUP,
        icon: undefined,
        index: 0,
        key: '',
        field: '',
        utils: {
          tags: {
            config: {
              showAsCard: true,
              tagsCardTitle: 'Team Size',
            },
          },
        },
        config: { labelKey: 'value', valueKey: 'value' },
        sections: { main: 2, more: 1 },
        items: [
          {
            name: 'Predefined Range',
            type: SearchFilterType.CHECK_BOX,
            icon: undefined,
            index: 0,
            layer: 4,
            key: 'employee_size',
            field: 'employee_size',
            metadata: {
              color: 'primary',
              metaDataApi: {
                enabled: true,
                key: MetadataType.COMPANY_EMPLOYEE_SIZE,
              },
            },
            config: { labelKey: 'label', valueKey: 'value' },
            options: [],
            nested: true,
            open: true,
          },
          {
            name: 'Custom Range',
            type: SearchFilterType.NUMBER_RANGE,
            icon: undefined,
            index: 0,
            layer: 4,
            key: 'employee_size_custom',
            field: 'employee_size_custom',
            metadata: {
              color: 'primary',
              numberRange: { hideTitle: true },
            },
            nested: true,
          },
          {
            name: 'Employee Size N/A',
            type: SearchFilterType.NOT_AVAILABLE,
            icon: undefined,
            index: 0,
            layer: 4,
            key: 'employee_size_availability',
            field: 'employee_size_availability',
            metadata: { color: 'primary' },
            nested: true,
            utils: {
              tags: {
                labelFormatter: (value: string) =>
                  capitalize(value.replace('_', ' ')),
              },
            },
          },
        ],
      },
    ],
  };
}
